function toggleLoader (target, loaderVisible) {
  const container = target.closest('.sprig-component')
  if (container) {
    if (loaderVisible) {
      container.scrollIntoView({ behavior: 'smooth' })
    }
    const results = container.querySelector('.feed-results')
    const loader = container.querySelector('.sprig-loader')
    if (results && loader) {
      if (loader.classList.contains('fade-results')) {
        results.style.opacity = loaderVisible ? 0.1 : 1
      } else {
        results.classList.toggle('is-hidden', loaderVisible)
      }
      loader.classList.toggle('is-hidden', !loaderVisible)
    }
  }
}

if (global.htmx) {
  global.htmx.on('htmx:afterSettle', (e) => {
    toggleLoader(e.target, false)
  })
  global.htmx.on('htmx:xhr:loadstart', (e) => {
    toggleLoader(e.target, true)
  })
}